import React from "react";
import { createRoot } from "react-dom/client";

import "./fonts/MontserratBlack.ttf";
import "./fonts/MontserratBold.ttf";
import "./fonts/MontserratItalic.ttf";
import "./fonts/MontserratLight.ttf";
import "./fonts/MontserratMedium.ttf";
import "./fonts/MontserratRegular.ttf";
import "./fonts/MontserratThin.ttf";

import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import { Provider } from "react-redux";
import store from "./store";

// replace console.* for disable log on production
if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
}
const container = document.getElementById("root");

const root = createRoot(container); //  createRoot(container!) if you use TypeScript

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
